import { render } from "./SettlementAdvanceCreateUpdate.vue?vue&type=template&id=5925f684"
import script from "./SettlementAdvanceCreateUpdate.vue?vue&type=script&lang=js"
export * from "./SettlementAdvanceCreateUpdate.vue?vue&type=script&lang=js"

import "./SettlementAdvanceCreateUpdate.vue?vue&type=style&index=0&id=5925f684&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__